export default __webpack_public_path__ + "static/media/neroandco-logo.35f06fd5.png";